import { useHistory } from 'react-router-dom';
import AppLayout from '../../../../../../component/appLayout';
import { getUrlParam, isEmpty } from '../../../../../../helpers/common';
import { useCallback, useEffect } from 'react';
import { ROUTES } from '../../../../../../routes/urls';
import { githubAccountConnect } from '../../../../../../services/githubServices';
import { rootStore } from '../../../../../../mobx/rootStore';
import { observer } from 'mobx-react-lite';

function GithubCallback() {
  //mobx states
  const { currentWorkspace } = rootStore.workspaceStore || {};

  // Other variables
  const history = useHistory();
  const installationId = getUrlParam(history.location.search, 'installation_id');

  const loadData = useCallback(async () => {
    if (!isEmpty(currentWorkspace?.id)) {
      // call service to add installation id
      if (installationId) {
        const response = await githubAccountConnect(installationId);
        if (response) {
          history.push(ROUTES.INTEGRATIONS_DETAILS);
        }
      }
    }
  }, [history, installationId, currentWorkspace?.id]);

  useEffect(() => {
    loadData();
  }, [loadData]);
  return <AppLayout>Loading ...</AppLayout>;
}

export default observer(GithubCallback);
